__turbopack_context__.v({
  "viewer": "SplineViewer-module__FI7baG__viewer",
});
